import React, { useEffect } from 'react'
import Select from 'react-select'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Button } from 'reactstrap';
import getUserStatusList from '@/service/getUserStatuses';
import getOrganizationList from '@/service/getOrganizationList';
import getRoleList from '../../../service/getRoles';
import { labelizeNamedData } from '@/shared/helpers'

import { setOrganization as setAuthOrganization, getOrganization, AUTH_ORGANIZATION_TREE } from "@/containers/App/auth";
import {setOrganization} from '@/redux/actions/organizationActions';
import store from '@/containers/App/store';

const UserFilter = ({ onClickFilterCallback, organization, auth }) => {
    const [statusOptions, setStatusOptions] = React.useState([])
    const [status, setStatus] = React.useState('')
    const [orgOptions, setOrgOptions] = React.useState([])
    const [org, setOrg] = React.useState('')
    const [roleOptions, setRoleOptions] = React.useState([])
    const [role, setRole] = React.useState('')
    const [keyword, setKeyword] = React.useState('')
    
    const onOrgChange = (selectedOption) => {
      setOrg(selectedOption.value)
      if( auth?.isSuperAdmin ) {
        if(selectedOption.value === "1") {
          setOrg("")
        }
        let newOrg = {name: selectedOption.label, id: parseInt(selectedOption.value)}
        store.dispatch(setOrganization(newOrg))
        setAuthOrganization(newOrg);
      }
    };
    
    const onStatusChange = (selectedOption) => {
        setStatus(selectedOption.value)
        //onClickFilter();
    };

    const onRoleChange = (selectedOption) => {
        setRole(selectedOption.value)
        //onClickFilter();
    };

    const onUserPhraseChange = (e) => {
        setKeyword(e.target.value);
        //onClickFilter();
    }

    const onClickFilter = (event) => {
        event.preventDefault();
       
        onClickFilterCallback(status, keyword, org, role)
    }

    

    useEffect(() => {
      if( auth && auth?.isSuperAdmin )
      {
          getOrganizationList()
          .then(list => {
              list.unshift({id:1, name: 'ALL'});
              setOrgOptions(
                  labelizeNamedData(list)
              )
          })
      }
    }, [auth])

    useEffect(() => {
      if( organization && organization?.id )
      {
        if( auth.isSuperAdmin )
        {
          if(organization.id === 1) {
            setOrg("")
          } else {
            setOrg(organization.id.toString())
          }
        } else {
          setOrg(organization.id.toString())
        }
      }
    }, [organization, orgOptions])

    useEffect(() => {
        if (organization?.id) {
            getUserStatusList(organization.id)
                .then(list => {
                    setStatusOptions(
                        [
                            ...[{ 'value': '', label: 'All' }],
                            ...labelizeNamedData(list, ["status", "status"])
                        ]
                    )
                })
        }
        // console.log(auth)
    }, [organization])

    useEffect(() => {
        if (organization?.id) {
            getRoleList(organization.id)
                .then(list => {
                    setRoleOptions(
                        [
                            ...[{'value': '', label: 'All'}],
                            ...labelizeNamedData(list.data, ['name', ['name']])
                        ]
                    )
                })
        }
    }, [organization])

    const statusPlaceholder = status ? status : 'All'
    const rolePlaceholder = role ? role : 'All'
    let orgPlaceholder = 'ALL'
    if (org && org !== "1") {
        orgPlaceholder = orgOptions.filter(o => o.value === org).map(o => o.label)
    }
    return (
        <form className="form__form-group" onSubmit={onClickFilter}>
            {auth?.isSuperAdmin &&
                <div className="col-md-2 px-0">
                    <p className="">Organization</p>
                    <div>
                        <Select
                            value={org}
                            onChange={onOrgChange}
                            options={orgOptions}
                            clearable={false}
                            className="react-select"
                            placeholder={orgPlaceholder}
                            classNamePrefix="react-select"
                        />
                    </div>
                </div>}
            <div className="col-md-2 pr-0">
                <p className="">Status</p>
                <div>
                    <Select
                        value={status}
                        onChange={onStatusChange}
                        options={statusOptions}
                        clearable={false}
                        className="react-select"
                        placeholder={statusPlaceholder}
                        classNamePrefix="react-select"
                    />
                </div>
            </div>
            <div className="col-md-2 pr-0">
                <p className="">Role</p>
                <div>
                    <Select
                        value={role}
                        onChange={onRoleChange}
                        options={roleOptions}
                        clearable={false}
                        className="react-select"
                        placeholder={rolePlaceholder}
                        classNamePrefix="react-select"
                    />
                </div>
            </div>
            <div className="col-md-6">
                <p className="col-md-10">Keyword</p>
                <div className='d-flex align-items-center'>
                    <div className='col-md-10'>
                        <input
                            value={keyword}
                            onChange={onUserPhraseChange}
                            type="text"
                            placeholder="Search by ID, email, name, Employee ID"
                        />
                    </div>
                    <div className="pl-0">
                        <div className="d-flex align-items-end ml-2">
                            <Button  
                                type='submit'
                                className="btn btn-sm btn-primary mb-0" 
                                color="#ffffff"
                            >
                                Filter
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}
export default withRouter(connect((state) => ({
    auth: state.auth,
    organization: state.organization
}))(UserFilter));